"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSAddAccessoriesComponent = void 0;
const account_service_1 = require("../../shared/services/account.service");
const shared_1 = require("../../shared");
class CSAddAccessoriesComponent {
    constructor(accountService, genericContentService, addLineService) {
        this.accountService = accountService;
        this.genericContentService = genericContentService;
        this.addLineService = addLineService;
    }
}
exports.CSAddAccessoriesComponent = CSAddAccessoriesComponent;
//# sourceMappingURL=addaccessories.component.js.map